import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pplus-effective-permissions-entity-types',
  templateUrl: './effective-permissions-entity-types.component.html',
  styleUrls: ['./effective-permissions-entity-types.component.scss']
})
export class EffectivePermissionsEntityTypesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
